export default __webpack_public_path__ + "c18f5a2bce125ab3b97bb9834aa55789.png";